import {
  AE_FLAG,
  BR_FLAG,
  DE_FLAG,
  ES_FLAG,
  FR_FLAG,
  JP_FLAG,
  RU_FLAG,
  GB_FLAG,
  TR_FLAG,
  IT_FLAG
  // KO_FLAG
} from './mediaUrls'

export const LANGUAGES_LIST = [
  {
    flagImgSrc: GB_FLAG,
    label: 'English',
    code: 'en'
  },
  {
    flagImgSrc: BR_FLAG,
    label: 'Português',
    code: 'pt'
  },
  {
    flagImgSrc: ES_FLAG,
    label: 'Español',
    code: 'es'
  },
  {
    flagImgSrc: DE_FLAG,
    label: 'Detusch',
    code: 'de'
  },
  {
    flagImgSrc: FR_FLAG,
    label: 'Français',
    code: 'fr'
  },
  {
    flagImgSrc: AE_FLAG,
    label: 'العربية',
    code: 'ar'
  },
  {
    flagImgSrc: JP_FLAG,
    label: '日本語',
    code: 'jp'
  },
  {
    flagImgSrc: TR_FLAG,
    label: 'Türkçe',
    code: 'tr'
  },
  {
    flagImgSrc: RU_FLAG,
    label: 'Русский',
    code: 'ru'
  },
  {
    flagImgSrc: IT_FLAG,
    label: 'Italiano',
    code: 'it'
  }
  // {
  //   flagImgSrc: KO_FLAG,
  //   label: '한국어',
  //   code: 'ko'
  // }
]
